module.exports = __webpack_public_path__ + "yahoo_logo.4bb29a210cc9a18222815f54874733da.png";